<!-- 平台价格策略调价 -->
<template>
   <div class="strategy-modal-content">
      <div class="strategy-form">
         <!-- 平台配置表格 -->
         <div class="platform-table">
            <el-table :data="platformList" border size="mini" style="width: 100%">
               <el-table-column label="上架" width="80" align="center">
                  <template slot-scope="scope">
                     <el-checkbox v-model="scope.row.enabled"></el-checkbox>
                  </template>
               </el-table-column>
               <el-table-column label="平台名称" width="120" align="center">
                  <template slot-scope="scope">
                     <span>{{ scope.row.appName }}</span>
                  </template>
               </el-table-column>

               <el-table-column label="单价(元)" width="120" align="center">
                  <template slot-scope="scope">
                     <el-input v-model="scope.row.price" :min="0" type="number" placeholder="0.00" size="mini"
                        style="width: 100%"></el-input>
                  </template>
               </el-table-column>
               <!-- <el-table-column label="库存数量" width="120" align="center">
                  <template slot-scope="scope">
                     <span>{{ scope.row.ableNum }}</span>
                  </template>
               </el-table-column>
               <el-table-column label="上架数量" width="120" align="center">
                  <template slot-scope="scope">
                     <el-input v-model="scope.row.maxNum" :min="0" type="number" placeholder="0" size="mini"
                        style="width: 100%"></el-input>
                  </template>
               </el-table-column> -->

               <el-table-column label="上架日期(星期)" :min-width="280" align="center">
                  <template slot-scope="scope">
                     <el-checkbox-group v-model="scope.row.weekDays" size="mini">
                        <el-checkbox label="1">一</el-checkbox>
                        <el-checkbox label="2">二</el-checkbox>
                        <el-checkbox label="3">三</el-checkbox>
                        <el-checkbox label="4">四</el-checkbox>
                        <el-checkbox label="5">五</el-checkbox>
                        <el-checkbox label="6">六</el-checkbox>
                        <el-checkbox label="7">日</el-checkbox>
                     </el-checkbox-group>
                  </template>
               </el-table-column>

               <el-table-column label="每日开始时间" :min-width="150" align="center">
                  <template slot-scope="scope">
                     <el-time-picker v-model="scope.row.dayStartTime" placeholder="选择开始时间" format="HH:mm:ss"
                        value-format="timestamp" size="mini" style="width: 100%"></el-time-picker>
                  </template>
               </el-table-column>

               <el-table-column label="每日结束时间" :min-width="150" align="center">
                  <template slot-scope="scope">
                     <el-time-picker v-model="scope.row.dayEndTime" placeholder="选择结束时间" format="HH:mm:ss"
                        value-format="timestamp" size="mini" style="width: 100%"></el-time-picker>
                  </template>
               </el-table-column>
            </el-table>
         </div>
      </div>

      <div class="dialog-footer">
         <el-button @click="drawerCancel">取 消</el-button>
         <el-button type="primary" @click="saveStrategy" :loading="saving">保 存</el-button>
      </div>
   </div>
</template>

<script>
export default {
   props: ["actionData"],
   name: "ptStrategyAdd",
   data() {
      return {
         saving: false,
         platformList: [],
         ableNum: 0
      }
   },
   computed: {},
   watch: {},
   methods: {
      // 初始化平台数据
      async initPlatformData() {
         try {
            const res = await this.$http.getPlatformList({
               bgsId: this.actionData.oldData.bgsId
            });
            if (res.status === 200) {
               this.platformList = res.result.map(platform => ({
                  ...platform,
                  enabled: false,           // 是否上架
                  price: 0,                // 单价
                  // maxNum: 0,            // 上架数量
                  weekDays: [1, 2, 3, 4, 5, 6, 7],           // 上架日期(星期)
                  dayStartTime: new Date(new Date().toLocaleDateString()).getTime() - 24 * 3600 * 1000,     // 每日开始时间(时间戳)
                  dayEndTime: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,        // 每日结束时间(时间戳)
                  // ableNum: this.ableNum
               }));
            }
         } catch (error) {
            console.error('获取平台列表失败:', error);
            this.$message.error('获取平台列表失败');
         }
      },



      // 保存策略
      async saveStrategy() {
         // 检查是否至少启用了一个平台



         // 验证启用的平台是否填写了必要信息
         // for (let platform of enabledPlatforms) {
         //   if (!platform.price || platform.price <= 0) {
         //     this.$message.error(`请填写${platform.appName}的单价`);
         //     return;
         //   }
         //   if (!platform.maxNum || platform.maxNum <= 0) {
         //     this.$message.error(`请填写${platform.appName}的上架数量`);
         //     return;
         //   }
         //   if (!platform.weekDays || platform.weekDays.length === 0) {
         //     this.$message.error(`请选择${platform.appName}的上架日期`);
         //     return;
         //   }
         //   if (!platform.dayStartTime) {
         //     this.$message.error(`请选择${platform.appName}的每日开始时间`);
         //     return;
         //   }
         //   if (!platform.dayEndTime) {
         //     this.$message.error(`请选择${platform.appName}的每日结束时间`);
         //     return;
         //   }
         // }

         this.saving = true;
         try {
            const strategyData = {
               bgsId: this.actionData.oldData.bgsId,
               detailList: this.platformList.map(platform => ({
                  appId: platform.appId,
                  appName: platform.appName,
                  price: platform.price,
                  maxNum: platform.maxNum,
                  roundWeek: platform.weekDays.join(','),
                  dayStartTime: platform.dayStartTime - this.startTime,
                  dayEndTime: platform.dayEndTime - this.startTime,
                  state: platform.enabled ? 1 : 0
               }))
            };

            // 这里调用保存接口
            const res = await this.$http.changePriceInfo(strategyData);
            if (res.status === 200) {
               this.$message.success('保存成功');
               this.$emit("drawerCancel", false);
               this.$emit("toDetail", strategyData);
               this.saving = false;
            } else {
               this.$message.error(res.message);
               this.saving = false;
            }

         } catch (error) {
            console.error('保存失败:', error);
            this.$message.error('保存失败');
            this.saving = false;
         }
      },

      // 取消操作
      drawerCancel() {
         this.$confirm("确认关闭弹窗吗？未保存的数据将丢失。", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.$emit("drawerCancel", false);
            })
            .catch(() => { });
      },

      // 获取价格信息并回显
      async getPriceInfoAndFillData() {
         try {
            const res = await this.$http.getPriceInfo({
               ids: [this.actionData.oldData.bgsId]
            });

            if (res.status === 200 && res.result) {
               console.log('获取价格信息成功:', res.result);
               this.fillFormData(res.result);
            }
         } catch (error) {
            console.error('获取价格信息失败:', error);
            this.$message.error('获取价格信息失败');
         }
      },

      // 填充表单数据
      fillFormData(priceData) {
         if (!priceData || !Array.isArray(priceData)) {
            return;
         }

         // 遍历价格数据，回显到对应的平台
         priceData.forEach(priceItem => {
            const platform = this.platformList.find(p => p.appId === priceItem.appId);
            if (platform) {
               platform.enabled = priceItem.state === 1; // state为1表示启用
               platform.price = priceItem.price || 0;
               platform.maxNum = priceItem.maxNum || 0;

               // 处理星期数据
               if (priceItem.roundWeek) {
                  platform.weekDays = priceItem.roundWeek.split(',').filter(day => day);
               } else {
                  platform.weekDays = [];
               }

               // 处理时间数据
               platform.dayStartTime = this.startTime + priceItem.dayStartTime || null;
               platform.dayEndTime = this.startTime + priceItem.dayEndTime || null;
            }
         });
      },

      // 初始化表单数据
      initFormData() {
         if (this.actionData && this.actionData.cate === 1 && this.actionData.oldData) {
            // 编辑模式，回显数据
            const oldData = this.actionData.oldData;
            // 回显平台配置
            if (oldData.platforms) {
               oldData.platforms.forEach(platformData => {
                  const platform = this.platformList.find(p => p.appId === platformData.appId);
                  if (platform) {
                     platform.enabled = true;
                     platform.price = platformData.price || 0;
                     // platform.maxNum = platformData.maxNum || 0;
                     platform.weekDays = platformData.weekDays || [];
                     platform.publishTime = platformData.publishTime || '';
                     // platform.ableNum = this.ableNum
                  }
               });
            }
         }
      }
   },
   async created() {
      this.startTime = new Date(new Date().toLocaleDateString()).getTime() - 24 * 3600 * 1000
      this.endTime = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1
      const oldData = this.actionData.oldData;
      // this.ableNum = oldData.ableNum
      await this.initPlatformData();
      // 获取价格信息并回显
      await this.getPriceInfoAndFillData();
      this.initFormData();
   }
}
</script>
<style scoped>
.strategy-modal-content {
   padding: 20px;
   max-height: 80vh;
   overflow-y: auto;
}

.strategy-form {
   width: 100%;
}

.platform-table {
   margin-bottom: 20px;
}

.dialog-footer {
   display: flex;
   justify-content: center;
   align-items: center;
   width: 100%;
   background: #fff;
   height: 60px;
   padding: 15px 20px;
   margin-top: 20px;
   border-top: 1px solid #eee;
   gap: 15px;
}

.dialog-footer .el-button {
   min-width: 100px;
   height: 36px;
}

/* 表格样式优化 */
::v-deep .el-table {
   border-radius: 6px;
   overflow: hidden;
}

::v-deep .el-table th {
   background-color: #f5f7fa;
   color: #606266;
   font-weight: 600;
   text-align: center;
}

::v-deep .el-table td {
   text-align: center;
   padding: 8px 0;
}

/* 输入框样式 */
::v-deep .el-input-number {
   width: 100%;
}

::v-deep .el-input-number .el-input__inner {
   text-align: center;
   padding: 0 8px;
}

::v-deep .el-time-picker {
   width: 100%;
}

::v-deep .el-time-picker .el-input__inner {
   text-align: center;
   padding: 0 8px;
}

/* 复选框组样式 */
::v-deep .el-checkbox-group {
   display: flex;
   justify-content: center;
   flex-wrap: wrap;
   gap: 5px;
}

::v-deep .el-checkbox-group .el-checkbox {
   margin-right: 8px;
   margin-bottom: 0;
}

::v-deep .el-checkbox-group .el-checkbox__label {
   font-size: 12px;
   padding-left: 5px;
}

/* 禁用状态样式 */
::v-deep .el-input-number.is-disabled .el-input__inner,
::v-deep .el-time-picker.is-disabled .el-input__inner {
   background-color: #f5f7fa;
   border-color: #e4e7ed;
   color: #c0c4cc;
}

::v-deep .el-checkbox-group.is-disabled .el-checkbox {
   color: #c0c4cc;
}

::v-deep .el-checkbox-group.is-disabled .el-checkbox__input.is-disabled .el-checkbox__inner {
   background-color: #f5f7fa;
   border-color: #e4e7ed;
}

/* 表格行悬停效果 */
::v-deep .el-table tbody tr:hover>td {
   background-color: #f5f7fa !important;
}

/* 响应式设计 */
@media (max-width: 1200px) {
   .strategy-modal-content {
      padding: 15px;
   }

   ::v-deep .el-table th,
   ::v-deep .el-table td {
      padding: 6px 0;
   }

   ::v-deep .el-checkbox-group .el-checkbox__label {
      font-size: 11px;
   }
}

/* 滚动条样式 */
.strategy-modal-content::-webkit-scrollbar {
   width: 6px;
}

.strategy-modal-content::-webkit-scrollbar-track {
   background: #f1f1f1;
   border-radius: 3px;
}

.strategy-modal-content::-webkit-scrollbar-thumb {
   background: #c1c1c1;
   border-radius: 3px;
}

.strategy-modal-content::-webkit-scrollbar-thumb:hover {
   background: #a8a8a8;
}

/* 表格内容居中对齐 */
::v-deep .el-table .cell {
   text-align: center;
}

/* 星期复选框样式优化 */
::v-deep .el-checkbox-group .el-checkbox {
   white-space: nowrap;
}

::v-deep .el-checkbox-group .el-checkbox:last-child {
   margin-right: 0;
}
</style>
